import isEmpty from 'lodash/isEmpty';
import * as yup from 'yup';
import { StringSchema } from 'yup';
import { projectsHttp } from '../http.projects';

function uniqueProject(this: StringSchema) {
  let lastInput: string | null = null;
  let lastResult: boolean = true;

  return this.test('unique-project', { key: 'uniqueProject' }, async (projectName) => {
    if (lastInput === projectName) {
      return lastResult;
    }

    if (isEmpty(projectName)) return true;

    lastInput = projectName!;
    return (lastResult = !(await projectsHttp.exists(projectName!)));
  });
}

yup.addMethod(yup.string, 'uniqueProject', uniqueProject);
